module.exports = __webpack_public_path__ + "static/media/file_download.b7ef3273.svg";